/* eslint-disable max-len */
import { AllieIconProps } from '../../../components';

export const PredictionIconLight: React.FC<AllieIconProps> = ({ size = 22, color = '#F04438' }) => (
  <svg width={size} height={size} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.5 11C0.5 5.20101 5.20101 0.5 11 0.5C16.799 0.5 21.5 5.20101 21.5 11C21.5 16.799 16.799 21.5 11 21.5C5.20101 21.5 0.5 16.799 0.5 11Z"
      fill="#FEF3F2"
    />
    <path
      d="M0.5 11C0.5 5.20101 5.20101 0.5 11 0.5C16.799 0.5 21.5 5.20101 21.5 11C21.5 16.799 16.799 21.5 11 21.5C5.20101 21.5 0.5 16.799 0.5 11Z"
      stroke="#FECDCA"
    />
    <g clipPath="url(#clip0_2687_3291)">
      <path
        d="M10.5 6.5H8.9C8.05992 6.5 7.63988 6.5 7.31901 6.66349C7.03677 6.8073 6.8073 7.03677 6.66349 7.31901C6.5 7.63988 6.5 8.05992 6.5 8.9V13.1C6.5 13.9401 6.5 14.3601 6.66349 14.681C6.8073 14.9632 7.03677 15.1927 7.31901 15.3365C7.63988 15.5 8.05992 15.5 8.9 15.5H13.1C13.9401 15.5 14.3601 15.5 14.681 15.3365C14.9632 15.1927 15.1927 14.9632 15.3365 14.681C15.5 14.3601 15.5 13.9401 15.5 13.1V11.5M11 9H13V11M12.75 6.75V6M14.7197 7.28033L15.25 6.75M15.2551 9.25H16.0051M6.5 11.6736C6.82597 11.7239 7.15994 11.75 7.5 11.75C9.69318 11.75 11.6327 10.6638 12.8098 9"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2687_3291">
        <rect width="12" height="12" fill="white" transform="translate(5 5)" />
      </clipPath>
    </defs>
  </svg>
);
